import React from "react";
import './Sectwo.css';

export default function(){
    return(

        <section className="sec-2">    {/* section two start with bg img and content */}

                <div className="container pt-md-5 pb-3">
                    <div className="row pt-md-5 justify-content-between">
                        <div className="col-12 col-md-6 pt-md-5">

                            <h1 className="pt-5 pt-md-0"><span className="main-heading fw-bold text-white ">Digital Currency</span></h1>
                            <h3  className=" fw-bold text-white">The Future of Trading.</h3>

                            <div className="pt-4 pb-md-3">
                                <a href="#" className="text-decoration-none  fs-4 btn-1 rounded p-3">Get Startde</a>
                            </div>

                        </div>

                        <div className="col-12 col-md-5 pt-5 pt-md-0">

                            <img src="images/slider-img.png" alt="" className="img-fluid" />

                        </div>

                    </div>
                </div>
       
        </section>                
    )
}